<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Employee Salary</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Salary</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <button
                      class="btn btn-primary dropdown-toggle view-icons"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      More
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item" @click="openDialogImport"
                        >Bulk Group Assignment</a
                      >
                      <a class="dropdown-item" @click="openDialogImportPayroll"
                        >Import Salary</a
                      >
                      <a class="dropdown-item" @click="openDialogUpdateFromGroup"
                        >Update From Group</a
                      >
                      <a class="dropdown-item" @click="openDialogReview"
                        >Salary Review</a
                      >
                      <a class="dropdown-item" @click="openDialogPercentageReview"
                        >Percentage Review</a
                      >
                      <a class="dropdown-item" @click="openDialogExport"
                        >Export Report</a
                      >
                    </div>
                <a href="#" class="btn add-btn mr-1" @click="openDialogGSlip"
                  ><i class="fa fa-file-invoice"></i> Generate Payslip</a
                >
                <a
                  href="#"
                  class="btn add-btn mr-1"
                  @click="openDialogGroupFrom"
                  ><i class="fa fa-clone"></i> Add From Group</a
                >
                <a href="#" class="btn add-btn mr-1" @click="openDialogCopyFrom"
                  ><i class="fa fa-copy"></i> Copy From</a
                >
                <a href="#" class="btn add-btn mr-1" @click="openDialog"
                  ><i class="fa fa-plus"></i> Add Salary</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterEmpId"
                  @keyup="searchempcode"
                  style="height: 55px !important"
                />
                <label class="focus-label">Employee Code</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterEmpName"
                  @keyup="searchTable"
                  style="height: 55px !important"
                />
                <label class="focus-label">Search Employee</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a @click="getFilter" class="btn btn-success btn-block">
                Search
              </a>
            </div>
          </div>
          <!-- /Search Filter -->

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <v-data-table
                  :headers="headers"
                  :items="sortGroup"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.check`]="{ item }">
                    <router-link
                      :to="{
                        name: 'salaryEmployeeItem',
                        params: { id: item.Employee.id }
                      }"
                      >Check Salary</router-link
                    >
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link
                        :to="{
                          name: 'salaryEmployeeItem',
                          params: { id: item.Employee.id }
                        }"
                        class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.Employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="item.Employee.passportPhoto"
                          width="38"
                          v-if="item.Employee.passportPhoto"
                      /></router-link>
                      <router-link
                        :to="{
                          name: 'salaryEmployeeItem',
                          params: { id: item.Employee.id }
                        }"
                        >{{
                          `${item.Employee.firstName} ${item.Employee.lastName}`
                        }}</router-link
                      >
                    </h2>
                  </template>
                  <template v-slot:[`item.Earning`]="{ item }">
                    {{
                      item.Earning.toFixed(2)
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </template>
                  <template v-slot:[`item.Deduction`]="{ item }">
                    {{
                      item.Deduction.toFixed(2)
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </template>
                  <template v-slot:[`item.Relief`]="{ item }">
                    {{
                      item.Relief.toFixed(2)
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </template>
                  <template v-slot:[`item.NetSalary`]="{ item }">
                    {{
                      item.NetSalary.toFixed(2)
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </template>
                  <template v-slot:[`item.edit`]="{ item }">
                    <a
                      class="dropdown-item"
                      @click="setEdit(item)"
                      data-toggle="modal"
                      data-target="#edit_department"
                      ><i class="fa fa-pencil m-r-5"></i> Edit</a
                    >
                  </template>
                  <template v-slot:[`item.delete`]="{ item }">
                    <a
                      class="dropdown-item"
                      @click="setDelete(item)"
                      data-toggle="modal"
                      data-target="#delete_department"
                      ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                    >
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Department Modal -->

        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Salary</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Employee <span class="text-danger">*</span></label>

                  <multiselectvue
                    class="from-control"
                    v-model="employeeNameAdd"
                    placeholder="Select Employee"
                    :custom-label="nameOfEmployeeAdd"
                    :options="employees"
                    :searchable="true"
                    @select="optionSelectedAdd"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.firstName }} {{ option.lastName }}</template
                    >
                  </multiselectvue>

                  <!-- <select class="form-control" v-model="employeeId">
                    <option disabled>Select Staff</option>
                    <option
                      v-for="member in employees"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.lastName + " " + member.firstName }}
                    </option>
                  </select> -->

                  <!-- <input class="form-control" type="text" v-model="departmentName" > -->
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <v-dialog v-model="dialogCopyFrom" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Copy From Employee</h5>
              <button type="button" class="close" @click="closeCopyFrom">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label
                    >From Employee <span class="text-danger">*</span></label
                  >

                  <multiselectvue
                    class="from-control"
                    v-model="employeeName"
                    placeholder="Select Employee"
                    :custom-label="nameOfEmployee"
                    :options="groups"
                    :searchable="true"
                    @select="optionSelected"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.Employee.firstName }}
                      {{ option.Employee.lastName }}</template
                    >
                  </multiselectvue>
                </div>
                <div class="form-group leave-duallist">
                  <label>To Employee(s)</label>
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group form-focus">
                      <input
                        type="text"
                        class="form-control floating"
                        v-model="filterToEmployee"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Search Employee</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="fromEmployee_select"
                        v-model="pickEmployees"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.id"
                          v-for="item in searchToGroup"
                          :key="item.id"
                          >{{ item.firstName + " " + item.lastName }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="fromEmployee_select_rightAll"
                        @click="selectedEmployeeAllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="fromEmployee_select_rightSelected"
                        @click="selectedEmployeeFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="fromEmployee_select_leftSelected"
                        @click="selectedEmployeeTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="fromEmployee_select_leftAll"
                        @click="selectedEmployeeAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="fromEmployee_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onCopyFrom"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <v-dialog v-model="dialogGSlip" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Generate Payslip</h5>
              <button type="button" class="close" @click="closeGSlip">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-md-12">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <form>
                <div class="form-group">
                  <label>Period Month <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="periodMonth">
                    <option disabled>Select Month</option>
                    <option>January</option>
                    <option>February</option>
                    <option>March</option>
                    <option>April</option>
                    <option>May</option>
                    <option>June</option>
                    <option>July</option>
                    <option>August</option>
                    <option>September</option>
                    <option>October</option>
                    <option>November</option>
                    <option>December</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Period Year <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="periodYear">
                    <option disabled>Select Year</option>
                    <option v-for="year in years" :key="year" :value="year">
                      {{ year }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label
                    >Generate for All Employee Salaries
                    <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="all">
                    <option disabled>Select Option</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
                <div class="form-group leave-duallist" v-if="all == false">
                  <label>For Employee(s)</label>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="SPayslip_select"
                        v-model="pickEmployees"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.Employee.id"
                          v-for="item in groups"
                          :key="item.Employee.id"
                          >{{
                            item.Employee.firstName +
                              " " +
                              item.Employee.lastName
                          }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="SPayslip_select_rightAll"
                        @click="selectedSlipAllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="SPayslip_select_rightSelected"
                        @click="selectedSlipFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="SPayslip_select_leftSelected"
                        @click="selectedSlipTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="SPayslip_select_leftAll"
                        @click="selectedSlipAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="SPayslip_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="generateSlip"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Bulk Group Assignment</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Group Assignment</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importGroup"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->

        <v-dialog v-model="dialogGroupFrom" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Copy From Group</h5>
              <button type="button" class="close" @click="closeGroupFrom">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>From Group <span class="text-danger">*</span></label>
                  <multiselectvue
                    class="from-control"
                    v-model="salaryGroupSelect"
                    placeholder="Select Salary Group"
                    :custom-label="nameOfSalaryGroup"
                    :options="salaryGroups"
                    :searchable="true"
                    @select="optionSelectedSalaryGroup"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.name }}
                    </template>
                  </multiselectvue>
                </div>
                <div class="form-group leave-duallist">
                  <label>To Employee(s)</label>
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group form-focus">
                      <input
                        type="text"
                        class="form-control floating"
                        v-model="filterToSalaryGroup"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Search Employee</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="fromGroup_select"
                        v-model="pickEmployees"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.id"
                          v-for="item in sortedEmployeeNames"
                          :key="item.id"
                          >{{ item.firstName + " " + item.lastName }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="fromGroup_select_rightAll"
                        @click="selectedGroupAllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="fromGroup_select_rightSelected"
                        @click="selectedGroupFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="fromGroup_select_leftSelected"
                        @click="selectedGroupTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="fromGroup_select_leftAll"
                        @click="selectedGroupAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="fromGroup_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onGroupFrom"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Department Modal -->
        <v-dialog v-model="dialogExport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Export Report</h5>
              <button type="button" class="close" @click="closeExport">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Period From <span class="text-danger">*</span></label>
                  <div class="row">
                    <div class="col-md-6">
                      <select  class="form-control" style="height: 55px !important;" v-model="startmonth">
                        <option>Select Month</option>
                        <option v-for="item in months" :key="item.value" :value="item.value">{{ item.label }}</option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <input type="number" v-model="startyear" id="startyear" name="startyear" placeholder="Year" class="form-control"/>
                    </div>
                  </div>
                  
                </div>
                <div class="form-group">
                  <label>Period To <span class="text-danger">*</span></label>
                  <div class="row">
                    <div class="col-md-6">
                      <select  class="form-control" style="height: 55px !important;" v-model="endmonth">
                        <option>Select Month</option>
                        <option v-for="item in months" :key="item.value" :value="item.value">{{ item.label }}</option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <input type="number" v-model="endyear" id="endyear" name="endyear" placeholder="Year" class="form-control"/>
                    </div>
                  </div>
                  
                </div>
                
                <div class="form-group">
                  <label
                    >Report Type
                    <span class="text-danger">*</span></label
                  >
                  <select
                        v-model="reportType"
                        class="form-control"
                      >
                        <option disabled>Select Option</option>
                        <option
                          :value="item.value"
                          v-for="item in reportTypes"
                          :key="item.value"
                          >{{
                            item.label
                          }}
                        </option>
                      </select>
                </div>
                <div class="form-group" v-if="reportType < 5">
                  <label
                    >Function
                    <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="parameter3">
                    <option disabled>Select Option</option>
                    <option :value="0">item List</option>
                    <option :value="1">Accumulated list</option>
                  </select>
                </div>
                <div class="form-group" v-else>
                  <label
                    >Loan Type
                    <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="parameter3">
                    <option disabled>Select Option</option>
                    <option
                          :value="item.id"
                          v-for="item in loanTypes"
                          :key="item.id"
                          >{{
                            item.description
                          }}
                        </option>
                  </select>
                </div>
                <div class="form-group" v-if="!parameter2">
                  <label
                    >Employee
                    </label
                  >
                  <input type="text" v-model="parameter1" id="employeeid" name="employeeid" placeholder="Employee Code" class="form-control"/>
                </div>
                <div class="form-group" v-if="!parameter1">
                  <label
                    >Department
                    </label
                  >
                  <select
                        v-model="parameter2"
                        class="form-control"
                      >
                        <option disabled>Select Option</option>
                        <option
                          :value="item.id"
                          v-for="item in departments"
                          :key="item.id"
                          >{{
                            item.name
                          }}
                        </option>
                      </select>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onExportReport"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Department Modal -->
        <v-dialog v-model="dialogPercentageReview" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Percentage Review</h5>
              <button type="button" class="close" @click="closePercentageReview">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Percentage <span class="text-danger">*</span></label>
                  <input
                    type="number"
                    v-model="percentage"
                    id="name"
                    name="name"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label
                    >Function
                    <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="crement">
                    <option disabled>Select Option</option>
                    <option :value="0">Increment</option>
                    <option :value="1">Decrement</option>
                  </select>
                </div>
                <div class="form-group">
                  <label
                    >Review for All Salary Grades
                    <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="all">
                    <option disabled>Select Option</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
                <div class="form-group leave-duallist" v-if="!all">
                  <label>To Group(s)</label>
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group form-focus">
                      <input
                        type="text"
                        class="form-control floating"
                        v-model="filterOnGroup"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Search Group</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="withGroup_select"
                        v-model="pickGroups"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.id"
                          v-for="item in sortedGroups"
                          :key="item.id"
                          >{{ item.name }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="withGroup_select_rightAll"
                        @click="selectedGroup2AllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="withGroup_select_rightSelected"
                        @click="selectedGroup2From"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="withGroup_select_leftSelected"
                        @click="selectedGroup2To"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="withGroup_select_leftAll"
                        @click="selectedGroup2AllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="withGroup_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onPercentageReview"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Department Modal -->
        <v-dialog v-model="dialogUpdateFromGroup" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Update From Group</h5>
              <button type="button" class="close" @click="closeUpdateFromGroup">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>From Group <span class="text-danger">*</span></label>
                  <multiselectvue
                    class="from-control"
                    v-model="salaryGroupSelect"
                    placeholder="Select Salary Group"
                    :custom-label="nameOfSalaryGroup"
                    :options="salaryGroups"
                    :searchable="true"
                    @select="optionSelectedSalaryGroup"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.name }}
                    </template>
                  </multiselectvue>
                </div>
                
                <div class="submit-section">
                  <button
                    @click.prevent="updateFromGroup"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Department Modal -->
        <!-- Delete Department Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Employee Salary</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="deleteGroup"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a @click="closeDelete" class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Department Modal -->
         <!-- Group payroll model box -->
        <v-dialog v-model="dialogImportPayroll" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Salary Payroll</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImportPayroll"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Salary Payroll</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplateEmployeePayroll"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importEmployeePayroll"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- Group payroll model box ends-->
        <!-- Delete Department Modal -->
        <v-dialog v-model="dialogReview" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Review Employee Salary</h3>
                <p>Are you sure want to update all Employee salaries?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      v-if="!loading"
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="reviewSalary"
                      data-dismiss="modal"
                      >Update</a
                    >
                    <a
                      v-if="loading"
                      class="btn btn-primary continue-btn"
                      >Loading...</a
                    >
                  </div>
                  <div class="col-6">
                    <a @click="closeReview" class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Department Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required } from "vuelidate/lib/validators";
import { authenticationService } from "@/services/authenticationService";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
import { paymentService } from "@/services/paymentService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      headers: [
        {
          text: "Employee Name",
          align: "start",
          value: "profile"
        },
        {
          text: "Employee Code",
          value: "Employee.employeeCode",
          sortable: false
        },
        { text: "Total Earnings", value: "Earning", sortable: false },
        { text: "Total Deductions", value: "Deduction", sortable: false },
        { text: "Total Reliefs", value: "Relief", sortable: false },
        { text: "Net Pay", value: "NetSalary", sortable: false },
        { text: "", value: "check", sortable: false },
        { text: "", value: "edit", sortable: false },
        { text: "", value: "delete", sortable: false }
      ],
      employeeId: "",
      groups: [],
      salaryGroups: [],
      employees: [],
      group: {},
      crement: 0,
      fromEmployeeId: null,
      fromGroupId: null,
      pickEmployees: [],
      pickGroups: [],
      selectedGroups: [],
      selectedEmployees: [],
      periodMonth: null,
      periodYear: new Date().getFullYear(),
      all: null,
      percentage: 0,
      submitted: false,
      company: authenticationService.currentOfficeValue,
      loading: false,
      error: "",
      message: "",
      departments: [],
      dialog: false,
      dialogReview: false,
      dialogCopyFrom: false,
      dialogGroupFrom: false,
      dialogPercentageReview: false,
      dialogGSlip: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogImportPayroll: false,
      dialogUpdateFromGroup: false,
      dialogExport: false,
      file: null,
      fileName: "",
      filterEmpName: "",
      filterEmpId: "",
      parameter2: null,
      parameter3: null,
      parameter1: null,
      startmonth: 0,
      startyear: '',
      endmonth: 0,
      endyear: '',
      reportType: 0,
      loanTypes: [],
      filterDesignationId: "",
      nofilterEmployees: [],
      designations: [],
      employeeName: null,
      toEmployee: null,
      filterToEmployee: "",
      salaryGroupSelect: null,
      filterToSalaryGroup: "",
      filterOnGroup: "",
      loading: false,
      months: [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" }
      ],
      reportTypes: [
        { value: 1, label: "Payslip Report" },
        { value: 2, label: "Payee Report" },
        { value: 3, label: "Pension Report" },
        { value: 4, label: "NHF Report" },
        { value: 5, label: "Loan Item Report" },
        { value: 6, label: "Loan Summary Report" },
      ],
      employeeNameAdd: null
    };
  },
  validations: {
    name: { required }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogCopyFrom(val) {
      val || this.closeCopyFrom();
    },
    dialogImport(val) {
      val || this.closeImport();
    },
    dialogImportPayroll(val) {
      val || this.closeImportPayroll();
    },
    dialogGroupFrom(val) {
      val || this.closeGroupFrom();
    },
    dialogPercentageReview(val) {
      val || this.closePercentageReview();
    },
    dialogGSlip(val) {
      val || this.closeGSlip();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogReview(val) {
      val || this.closeReview();
    },
    dialogExport(val) {
      val || this.closeExport();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogUpdateFromGroup(val) {
      val || this.closeUpdateFromGroup();
    }
  },
  computed: {
    years: () => {
      var res = [];
      var currentYear = new Date().getFullYear();
      var currentYear = currentYear - 1;
      for (var i = currentYear; i < currentYear + 20; i++) {
        res.push(i);
      }

      return res;
    },

    // searchSalaryList: function() {
    //   return this.groups.filter(d =>
    //     this.filterEmpName != ""
    //       ? d.Employee.firstName
    //           .toLowerCase()
    //           .includes(this.filterEmpName.toLowerCase()) ||
    //         d.Employee.lastName
    //           .toLowerCase()
    //           .includes(this.filterEmpName.toLowerCase()) ||
    //         (d.Employee.employeeCode != null &&
    //           d.Employee.employeeCode
    //             .toLowerCase()
    //             .includes(this.filterEmpName.toLowerCase()))
    //       : true
    //   );
    // },
    
    sortedEmployeeNames: function() {
      return this.employees.filter(
        d =>
          d.firstName
            .toLowerCase()
            .includes(this.filterToSalaryGroup.toLowerCase()) ||
          d.lastName
            .toLowerCase()
            .includes(this.filterToSalaryGroup.toLowerCase())
      );
    },

    sortedGroups: function() {
      if(this.filterOnGroup != ''){
      return this.salaryGroups.filter(
        d =>
          d.name
            .toLowerCase()
            .includes(this.filterOnGroup.toLowerCase())
      );
      }else{
        return this.salaryGroups
      }
    },

    searchToGroup: function() {
      return this.employees.filter(
        d =>
          d.firstName
            .toLowerCase()
            .includes(this.filterToEmployee.toLowerCase()) ||
          d.lastName.toLowerCase().includes(this.filterToEmployee.toLowerCase())
      );
    },

    sortGroup: function() {
      function compare(a, b) {
        if (
          a.Employee.firstName.toLowerCase() <
          b.Employee.firstName.toLowerCase()
        )
          return -1;
        if (
          a.Employee.firstName.toLowerCase() >
          b.Employee.firstName.toLowerCase()
        )
          return 1;
        return 0;
      }

      return this.groups ? this.groups.sort(compare) : this.groups;
    }

    // sortedEmployeeNames: function() {
    //   function compare(a, b) {
    //     if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
    //     if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
    //     return 0;
    //   }

    //   return this.employees ? this.employees.sort(compare) : this.employees;
    // }
  },

  methods: {
    searchTable() {
      this.groups = this.nofilterEmployees.filter(
        c =>
          c.Employee.firstName
            .toLowerCase()
            .includes(this.filterEmpName.toLowerCase()) ||
          c.Employee.lastName
            .toLowerCase()
            .includes(this.filterEmpName.toLowerCase())
      );
    },

    searchempcode() {
      this.groups = this.nofilterEmployees.filter(c =>
        c.Employee.employeeCode
          .toLowerCase()
          .includes(this.filterEmpId.toLowerCase())
      );
    },
    nameOfEmployeeAdd({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },

    optionSelectedAdd(option, id) {
      console.log(option.id);
      this.employeeId = option.id;
    },

    nameOfEmployee({ Employee }) {
      return `${Employee.firstName} ${Employee.lastName}`;
    },

    optionSelected(option, id) {
      console.log(option.EmployeeId);
      this.fromEmployeeId = option.EmployeeId;
    },

    nameOfSalaryGroup({ name }) {
      return `${name}`;
    },

    optionSelectedSalaryGroup(option, id) {
      console.log(option.id);
      this.fromGroupId = option.id;
    },

    getFilter() {
      console.log(this.filterEmpId, this.groups);
      this.groups = this.nofilterEmployees;
      var employee = [];
      if (this.filterEmpId) {
        this.groups = this.nofilterEmployees.filter(c =>
          c.Employee.employeeCode
            .toLowerCase()
            .includes(this.filterEmpId.toLowerCase())
        );
      } else if (this.filterEmpName) {
        this.groups = this.nofilterEmployees.filter(
          c =>
            c.Employee.firstName
              .toLowerCase()
              .includes(this.filterEmpName.toLowerCase()) ||
            c.Employee.lastName
              .toLowerCase()
              .includes(this.filterEmpName.toLowerCase())
        );
      }
      if (!this.filterEmpId && !this.filterEmpName) {
        this.groups = this.nofilterEmployees;
      }
    },

    clearModel() {
      this.name = "";
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeImport() {
      this.dialogImport = false;
    },
    closeExport() {
      this.dialogExport = false;
    },
    closeUpdateFromGroup() {
      this.dialogUpdateFromGroup = false
    },
    openDialogUpdateFromGroup() {
      this.dialogUpdateFromGroup = true;
    },

    openDialogImportPayroll() {
      this.dialogImportPayroll = true;
    },

    closeCopyFrom() {
      this.dialogCopyFrom = false;
      this.fromEmployeeId = null;
      this.employeeName = null;
      this.pickEmployees = [];
      this.selectedEmployees = [];
    },

    closeGSlip() {
      this.dialogGSlip = false;
      this.periodMonth = null;
      this.periodYear = new Date().getFullYear();
      this.all = null;
      this.pickEmployees = [];
      this.selectedEmployees = [];
    },

    closeGroupFrom() {
      this.dialogGroupFrom = false;
      this.fromGroupId = null;
      this.salaryGroupSelect = null;
      this.pickEmployees = [];
      this.selectedEmployees = [];
    },
    closePercentageReview() {
      this.dialogPercentageReview = false;
      this.percentage = 0;
      this.pickGroups = [];
      this.selectGroups = [];
    },
    closeImportPayroll() {
      this.dialogImportPayroll = false;
    },
    openDialog() {
      this.dialog = true;
      this.sortEmployees();
    },
    openDialogImport() {
      this.dialogImport = true;
    },
    openDialogExport() {
      this.dialogExport = true;
    },

    openDialogCopyFrom() {
      this.dialogCopyFrom = true;
      this.sortEmployeesFromGroup();
      this.sortEmployees();
    },

    openDialogGSlip() {
      this.dialogGSlip = true;
    },
    openDialogReview() {
      this.dialogReview = true;
    },

    openDialogGroupFrom() {
      this.dialogGroupFrom = true;
      this.sortEmployees();
    },
    openDialogPercentageReview() {
      this.dialogPercentageReview = true;
      this.sortGroups();
    },

    closeEdit() {
      this.dialogEdit = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },
    closeReview() {
      this.dialogReview = false;
    },

    setEdit(model) {
      this.group = model;
      this.dialogEdit = true;
    },

    setDelete(model) {
      this.group = model;
      this.dialogDelete = true;
    },
    selectedSlipAllFrom() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select_to")
        .append(selectOption);
      this.selectedEmployees = this.employees;
    },
    selectedSlipFrom() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select_to")
        .append(selectOption);
      this.selectedEmployees.push(this.pickEmployees[0]);
      // console.log(this.selectedEmployees)
    },
    selectedSlipAllTo() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select")
        .append(selectOption);

      this.selectedEmployees = [];
    },
    selectedSlipTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#SPayslip_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#SPayslip_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedPrograms));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedEmployees = data;
        // console.log(this.selectedEmployees)
      });
    },
    selectedEmployeeAllFrom() {
      var selectOption = [];
      $(document)
        .find("#fromEmployee_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromEmployee_select_to")
        .append(selectOption);
      this.selectedEmployees = this.employees;
    },
    selectedEmployeeFrom() {
      var selectOption = [];
      $(document)
        .find("#fromEmployee_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromEmployee_select_to")
        .append(selectOption);
      this.selectedEmployees.push(...this.pickEmployees);
      // console.log(this.selectedEmployees)
    },
    selectedEmployeeAllTo() {
      var selectOption = [];
      $(document)
        .find("#fromEmployee_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromEmployee_select")
        .append(selectOption);

      this.selectedEmployees = [];
    },
    selectedEmployeeTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#fromEmployee_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#fromEmployee_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedPrograms));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedEmployees = data;
        // console.log(this.selectedEmployees)
      });
    },
    selectedGroupAllFrom() {
      var selectOption = [];
      $(document)
        .find("#fromGroup_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromGroup_select_to")
        .append(selectOption);
      this.selectedEmployees = this.employees;
    },
    selectedGroupFrom() {
      console.log(this.pickEmployees);
      var selectOption = [];
      $(document)
        .find("#fromGroup_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromGroup_select_to")
        .append(selectOption);
      this.selectedEmployees.push(...this.pickEmployees);
    },
    selectedGroupAllTo() {
      var selectOption = [];
      $(document)
        .find("#fromGroup_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromGroup_select")
        .append(selectOption);

      this.selectedEmployees = [];
    },
    selectedGroupTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#fromGroup_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#fromGroup_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedPrograms));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedEmployees = data;
        // console.log(this.selectedEmployees)
      });
    },
    selectedGroup2AllFrom() {
      var selectOption = [];
      $(document)
        .find("#withGroup_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#withGroup_select_to")
        .append(selectOption);
      this.selectedGroups = this.salaryGroups;
    },
    selectedGroup2From() {
      console.log(this.pickGroups);
      var selectOption = [];
      $(document)
        .find("#withGroup_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#withGroup_select_to")
        .append(selectOption);
      this.selectedGroups.push(...this.pickGroups);
    },
    selectedGroup2AllTo() {
      var selectOption = [];
      $(document)
        .find("#withGroup_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#withGroup_select")
        .append(selectOption);

      this.selectedGroups = [];
    },
    selectedGroup2To() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#withGroup_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#withGroup_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedPrograms));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedGroups = data;
        // console.log(this.selectedEmployees)
      });
    },
    downloadTemplate() {
      paymentService
        .downloadAssignGroupTemplate(this.company.id)
        .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        });
    },
    importGroup() {
      paymentService.importAssignGroup(this.company.id, this.file).then(
        response => {
          const companyId = this.company.id;
          paymentService.getEmployeeSalaries(this.company.id).then(
            model => {
              this.groups = model;
              //console.log(model)
              this.closeImport();
            },
            error => {
              error = error;
            }
          );
        },
        error => {
          this.error = error;
        }
      );
    },
    // Group payroll import and export functions starts here
    downloadTemplateEmployeePayroll() {
      paymentService
        .downloadEmployeePayrollTemplate(this.company.id)
        .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        });
    },
    importEmployeePayroll() {
      paymentService.importEmployeePayroll(this.company.id, this.file).then(
        response => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          paymentService.getEmployeeSalaries(unit.id).then(
            model => {
              this.groups = model.filter(p => p.Employee.status !== 8);
              this.nofilterEmployees = model.filter(p => p.Employee.status !== 8);
              console.log(this.groups);
              this.closeImportPayroll()
            })
        },
        error => {
          this.error = error;
        }
      );
    },
    reviewSalary() {
      this.loading = true;
      paymentService.salaryReview(this.company.id).then(
        response => {
          paymentService.getEmployeeSalaries(this.company.id).then(
            model => {
              this.groups = model;
              this.loading = false;
              //console.log(model)
              this.closeReview();
            },
            error => {
              error = error;
            }
          );
        },
        error => {
          this.error = error;
        }
      );
    },

    updateFromGroup() {
      this.loading = true;
      paymentService.UpdateFromGroup(this.fromGroupId).then(
        response => {
          paymentService.getEmployeeSalaries(this.company.id).then(
            model => {
              this.groups = model;
              this.loading = false;
              //console.log(model)
              this.closeUpdateFromGroup();
            },
            error => {
              error = error;
            }
          );
        },
        error => {
          this.error = error;
        }
      );
    },

    getDepartments() {
      organizationService.getDepartments().then(
        model => {
          this.departments = model;
          //console.log(model)
        },
        error => {
          error = error;
        }
      );
    },

    sortEmployees() {
      this.employees.sort(function(a, b) {
        let x = a.firstName.toLowerCase();
        let y = b.firstName.toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    },

    sortGroups() {
      this.salaryGroups.sort(function(a, b) {
        let x = a.name.toLowerCase();
        let y = b.name.toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    },

    sortEmployeesFromGroup() {
      this.groups.sort(function(a, b) {
        let x = a.Employee.firstName.toLowerCase();
        let y = b.Employee.firstName.toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    },

    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployees(unit.id).then(
        model => {
          var salaryEmployees = this.groups.map(i => i.EmployeeId);
          this.employees = model.filter(c => !salaryEmployees.includes(c.id));
          // console.log(this.employees);
        },
        error => {
          error = error;
        }
      );
    },
    getLoanTypes() {
      employeeService.getLoanTypes(this.company.id).then(
        model => {
          this.loanTypes = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getGroups() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      paymentService.getEmployeeSalaries(unit.id).then(
        model => {
          this.groups = model.filter(p => p.Employee.status !== 8);
          this.nofilterEmployees = model.filter(p => p.Employee.status !== 8);
          console.log(this.groups);
          this.getEmployees();
        },
        error => {
          error = error;
        }
      );
    },
    getSalaryGroups() {
      paymentService.getSalaryGroups(this.company.id).then(
        model => {
          this.salaryGroups = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    updateGroup() {
      this.submitted = true;

      this.loading = true;
      var req = {
        companyId: this.company.id,
        name: this.name
      };
      paymentService.updateSalaryGroup(req).then(
        id => {
          paymentService.getSalaryGroups(this.company.id).then(o => {
            this.groups = o;
            this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    setGroup(item) {
      this.group = item;
    },
    deleteGroup() {
      //console.log(this.department)
      const id = this.group.employeeId;
      paymentService.removeEmployeeSalaries(id).then(
        id => {
          paymentService.getEmployeeSalaries(this.company.id).then(o => {
            this.groups = o;
            this.closeDelete();
          });
        },
        e => {
          this.error = "Group being used in some information";
          this.closeDelete();
        }
      );
    },
    onSubmit() {
      this.submitted = true;
      this.$router.push({
        name: "salaryEmployeeItem",
        params: { id: this.employeeId }
      });
    },
    onCopyFrom() {
      if (this.selectedEmployees.length == 0) {
        return;
      }
      this.loading = true;
      var req = {
        from: this.fromEmployeeId,
        to: this.selectedEmployees,
        companyId: this.company.id
      };

      paymentService.copyFrom(req).then(
        id => {
          this.getGroups();
          this.closeCopyFrom();
          this.loading = false;
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onGroupFrom() {
      if (this.selectedEmployees.length == 0) {
        return;
      }
      this.loading = true;
      var req = {
        from: this.fromGroupId,
        to: this.selectedEmployees,
        companyId: this.company.id
      };

      paymentService.groupFrom(req).then(
        id => {
          this.getGroups();

          this.closeGroupFrom();
          this.loading = false;
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onPercentageReview() {
      if (this.selectedGroups.length == 0) {
        return;
      }
      this.loading = true;
      var req = {
        percentage: parseInt(this.percentage),
        crement: this.crement,
        all: this.all,
        to: this.selectedGroups,
        companyId: this.company.id
      };

      paymentService.percentageReview(req).then(
        id => {
          this.getGroups();

          this.closePercentageReview();
          this.loading = false;
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onExportReport() {
      if (this.reportType == 0 || this.startmonth == 0 || this.endmonth == 0 || this.startyear == 0 || this.endyear == 0) {
        return;
      }
      this.loading = true;
      var req = {
        reportType: this.reportType,
        startPeriodMonth: this.startmonth,
        startPeriodYear: this.startyear,
        endPeriodMonth: this.endmonth,
        endPeriodYear: this.endyear,
        parameterId1: this.parameter1,
        parameterId2: this.parameter2,
        parameterId3: this.parameter3
      };
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      paymentService.exportReport(unit.id, req)
      .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
          this.loading = false;
        }).catch((error) => {
            alert(error);
            this.loading = false;
        });
    },

    generateSlip() {
      if (this.selectedEmployees.length == 0 && !this.all) {
        return;
      }
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      this.loading = true;
      var req = {
        periodMonth: this.periodMonth,
        periodYear: this.periodYear,
        all: this.all,
        selectedEmployees: this.selectedEmployees,
        companyId: unit.id
      };

      paymentService.generateSlip(req).then(
        id => {
          this.message = `Payslip for ${this.periodMonth} generated successfully`;
          this.loading = false;
          this.closeGSlip();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    getDesignations() {
      organizationService.getDesignations().then(
        model => {
          this.designations = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    }
  },
  mounted() {
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
    this.getDesignations();
    this.getGroups();
    this.getSalaryGroups();
    this.getLoanTypes();
    this.sortEmployees();
    this.getDepartments();
    console.log(this.groups);
  },
  name: "companydepartments"
};
</script>



// WEBPACK FOOTER //
// src/components/payroll/salaryEmployee.vue